"use client";

import React from "react";
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-32 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-2 text-sm text-muted-foreground font-sans">
        <li><Link to="/ProductsPage" className="hover:text-secondary transition-colors">Prodotti</Link></li>
        <li><Link to="/AboutUsPage" className="hover:text-secondary transition-colors">Chi Siamo</Link></li>
        <li><Link to="/ContactPage" className="hover:text-secondary transition-colors">Contatti</Link></li>
      </ul>;
  }
  return <NavigationMenu viewport={false} className="max-w-full justify-start">
      <NavigationMenuList className="flex-col items-start gap-1 space-x-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="w-full justify-start px-2 py-1.5 h-auto text-muted-foreground hover:text-secondary hover:bg-white/5 font-sans text-sm">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function PiedDePage() {
  const socials = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }];
  const paymentMethods = [{
    name: "Visa",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/payment_visa_secure.png"
  }, {
    name: "Mastercard",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/payment_mastercard_secure.png"
  }, {
    name: "PayPal",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/payment_paypal_secure.png"
  }];
  const legalLinks = [{
    label: "Note Legali",
    href: "#"
  }, {
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Termini e Condizioni",
    href: "#"
  }];
  return <section data-section-id="264807" id="footer" className="bg-[#1a252f] text-white pt-16 pb-8 border-t border-white/10">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto text-white" />
            </Link>
            <p className="text-sm text-slate-300 font-default mb-6 leading-relaxed">Solid Green Italia&nbsp; è il partner strategico per l'agricoltura sostenibile, offrendo tecnologie all'avanguardia per l'ottimizzazione delle risorse idriche.</p>
            <div className="flex gap-2">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Button key={i} data-index={i} variant="ghost" size="icon" asChild className="rounded-lg bg-slate-700/50 hover:bg-secondary hover:text-white text-white" aria-label={social.label}>
                    <Link to={social.href}>
                      <Icon className="size-5" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg text-white mb-6">Link Rapidi</h3>
            <MenuProvider menu_id="46">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg text-white mb-6">Contatti</h3>
            <ul className="space-y-4 text-sm text-slate-300 font-default">
              <li className="flex items-start gap-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-map-pin size-5 mt-0.5 shrink-0 text-secondary" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:b35beo" data-ast-start="4557" data-ast-end="5095"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:9wbx5r" data-ast-start="4932" data-ast-end="5050"></path><circle cx="12" cy="10" r="3" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:65e2m0" data-ast-start="5050" data-ast-end="5089"></circle></svg><span data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:gob5hf" data-ast-start="5095" data-ast-end="5242">Via&nbsp; P.Togliatti 39, 22066, Mariano C.se , Italia</span></li>
              <li className="flex items-center gap-3">
                <Phone className="size-5 shrink-0 text-secondary" />
                <span>+39 352 072 3180</span>
              </li>
              <li className="flex items-center gap-3"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-mail size-5 shrink-0 text-secondary" aria-hidden="true" data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:povn60" data-ast-start="4987" data-ast-end="5038"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path><rect x="2" y="4" width="20" height="16" rx="2"></rect></svg><span data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:godpfj" data-ast-start="5055" data-ast-end="5092">info@solidgreenitalia.com</span></li>
              <li className="flex items-start gap-3">
                <Clock className="size-5 mt-0.5 shrink-0 text-secondary" />
                <span>Lun - Ven: 09:00 - 18:00</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg text-white mb-6">Sostenibilità Certificata</h3>
            <p className="text-sm text-slate-300 font-default mb-4">
              Tecnologie validate per il risparmio idrico e la rigenerazione del suolo.
            </p>
            <div className="flex flex-wrap gap-3">
              {paymentMethods.map((method, i) => <div key={i} data-index={i} className="bg-white/5 p-2 rounded-md border border-white/10 shadow-md flex items-center justify-center h-10 w-16">
                  <img src={method.src} alt={`Certificazione ${method.name}`} className="max-h-full max-w-full object-contain brightness-0 invert" data-wvc-srcset={`${method.src}-wvc-srcset`} data-wvc-sizes={`${method.src}-wvc-sizes`} loading="lazy" />
                </div>)}
            </div>
          </div>

        </div>

        <Separator className="my-8 bg-white/10" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-400 font-default">
          <p>© 2026 Solid Green Italia S.R.L.S. Ogni goccia conta.</p>
          <ul className="flex flex-wrap items-center gap-4 md:gap-6">
            {legalLinks.map((link, i) => <li key={i} data-index={i}>
                <Link to={link.href} className="hover:text-secondary transition-colors">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}